<template>
  <div id="app">
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link to="/" class="navbar-item">
          <b-icon icon="home"></b-icon>
        </router-link>
        <div
          :class="['navbar-burger burger', { 'is-active': burger }]"
          @click="burger = !burger">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="navbarMenu" :class="['navbar-menu', { 'is-active': burger }]">
        <div class="navbar-start">
          <router-link to="/projects" class="navbar-item">Projects</router-link>
          <router-link to="/providers" class="navbar-item">Providers</router-link>
          <router-link to="/partners" class="navbar-item">Partners</router-link>
          <router-link to="/payment_methods" class="navbar-item">Payment Methods</router-link>
        </div>
      </div>
    </nav>
    <div class="column">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      burger: false,
    }
  },
}
</script>

<style>
input[type='submit'], a.button {
  margin-top: 15px;
}
.fa.fa-exclamation-triangle {
  color: red;
}
.b-tabs .tabs {
  margin-bottom: 15px;
}
.switch {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue